import { render, staticRenderFns } from "./CategoryPage.vue?vue&type=template&id=70793ea8&scoped=true"
import script from "./CategoryPage.vue?vue&type=script&lang=js"
export * from "./CategoryPage.vue?vue&type=script&lang=js"
import style0 from "./CategoryPage.vue?vue&type=style&index=0&id=70793ea8&prod&lang=scss&scoped=true"
import style1 from "./CategoryPage.vue?vue&type=style&index=1&id=70793ea8&prod&labg=scss&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70793ea8",
  null
  
)

export default component.exports